import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Layout from '../../components/Layout';
import { DE } from '../../Languages/DE';
import { EN } from '../../Languages/EN';
import LanguageContext from '../../helper/LanguageContext';
import { callAPI } from "../../helper/apiUtils";
import { Scrollbars } from 'react-custom-scrollbars';
import { convertPosition } from '../../helper/convertor';
import { useSelector } from 'react-redux';
import "./Companies.css";

const renderThumb = ({ style, ...props }) => {
    const thumbStyle = {
        borderRadius: 6,
        backgroundColor: 'rgba(var(--kjuup-accent-rgb), 0.8)'
    };
    return <div className="thumb-style" style={{ ...style, ...thumbStyle }} {...props} />;
};

const CustomScrollbars = props => (
    <Scrollbars
        renderThumbHorizontal={renderThumb}
        renderThumbVertical={renderThumb}
        {...props}
    />
);

function Companies(props) {
    let data = props.location.state
    console.log(data)
    const { isGerm, strings } = React.useContext(LanguageContext)
    const history = useHistory();
    const [companies, setCompanies] = useState([])
    const getCompanies = async () => {
        const { data } = await callAPI(`/company/my`, {}, 'GET')
        if (data.status) {
            const companies = data.companies.filter(company => (company.position == 'COMPANY ADMIN') || (company.role === 'ROLE_COMPANY_DEPARTMENT_ADMIN'))
            setCompanies(companies)         
        }
    }
    useEffect(() => {
        getCompanies();
    }, [])

    const getCompanyDetails = (id) => {
        history.push({
            pathname: '/cockpit',
            search: `?tab=company&company=${encodeURIComponent(id)}`,
            state: { id: id }
        })
    }

    const isDeskTopResolution = useSelector(state => state.isDeskTopResolution)
    return (
        <React.Fragment>
            <div className="companies d-flex flex-column w-100">
                <div className="company_border companies__header">
                    <div class="heading_icon m-0">
                        <Link to="/articles" className="main_heading">
                            <span 
                                className="material-symbols-outlined companies__back-icon"
                            >
                                keyboard_arrow_left
                            </span>{strings.company_selection}
                        </Link>
                    </div>
                </div>
                <div className="companies__body">
                    <CustomScrollbars autoHide autoHideTimeout={500} autoHideDuration={200}
                        className="bottom-bar">
                        {
                            companies &&
                            companies.map(company => (
                                company.isKjuup ?
                                    <div className="bg-purple companies__item" key={company.id}>
                                        <div className="profile-flied m-0">
                                            <Link to={
                                                {
                                                    pathname: `/add-company-article/${company.id}`,
                                                    state: { from: "external", companyId: company.id, fromFeeds: true }
                                                }
                                            }
                                                className="companies__link">
                                                <div className="profile_name">
                                                    <h3 className="pointer"
                                                        onClick={e => getCompanyDetails(company.id)}>{company.name}</h3>
                                                    <p>
                                                        {company.full_address? company.full_address : 
                                                          `${company.street}, ${company.postCode}, ${company.city}`}</p>
                                                    {company.owner ?
                                                        <p>{strings.owner_company_admin}<span
                                                            className="theme-color"> {company.owner}</span>
                                                        </p> : ''}
                                                    <p>{company.branch}</p>
                                                    <p>{strings.my_position} {convertPosition(isGerm, company.position)}</p>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    :
                                    <></>
                            ))
                        }
                        {
                            !companies &&
                            <div className="bg-purple">
                                <p className="text-center">{strings.record_not_found}</p>
                            </div>
                        }
                    </CustomScrollbars>
                </div>
            </div>
        </React.Fragment>
    );
}

export default Companies;
